(function () {
  function visibleVideo(root) {
    var mobile = window.matchMedia('(max-width: 899px)').matches;
    var selector = mobile ? 'video.wt-desktop-hidden' : 'video.wt-mobile-hidden';
    return root.querySelector(selector) || root.querySelector('video:not(.wt-desktop-hidden):not(.wt-mobile-hidden)');
  }

  function activate(video) {
    if (!video) return;
    if (!video.dataset.sourcesLoaded) {
      video.querySelectorAll('source[data-src]').forEach(function (source) {
        source.src = source.dataset.src;
      });
      video.dataset.sourcesLoaded = 'true';
      video.load();
    }
    video.muted = true;
    var play = video.play();
    if (play && play.catch) play.catch(function () {});
  }

  function pause(video) {
    if (video) video.pause();
  }

  function init(host) {
    var root = host.querySelector('.hero--video-background');
    if (!root || !('IntersectionObserver' in window)) return;
    var active;
    var observer = new IntersectionObserver(function (entries) {
      var entry = entries[0];
      var next = entry.isIntersecting ? visibleVideo(root) : null;
      if (active && active !== next) pause(active);
      active = next;
      if (entry.isIntersecting) activate(active);
    }, { threshold: 0.01 });
    observer.observe(root);
    host._backgroundVideoObserver = observer;
    window.addEventListener('resize', function () {
      if (!document.hidden) {
        var next = visibleVideo(root);
        if (next !== active) { pause(active); active = next; if (next && root.getBoundingClientRect().top < window.innerHeight && root.getBoundingClientRect().bottom > 0) activate(next); }
      }
    });
  }

  document.querySelectorAll('low-power-video').forEach(init);
})();
